import React from 'react';
import { Card, CardContent } from './ui/card';
import { galleryItems } from '../mock';

export const Gallery = () => {
  return (
    <section id="gallery" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-[#1c2536]/10 rounded-full mb-4 sm:mb-6">
            <span className="text-[#1c2536] font-semibold text-xs sm:text-sm">PORTFOLIO</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Our Recent Work
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-2">
            Browse our collection of beautifully crafted fitted furniture projects
          </p>
        </div>

        {/* Gallery Grid */}
        {galleryItems.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
            {galleryItems.map((item) => (
              <Card
                key={item.id}
                className="group overflow-hidden border-gray-200 hover:border-[#1c2536]/30 hover:shadow-2xl transition-all duration-300 cursor-pointer"
              >
                <CardContent className="p-0">
                  {/* Image */}
                  <div className="relative aspect-[4/3] sm:h-64 md:h-72 bg-gradient-to-br from-stone-100 to-stone-200 overflow-hidden">
                    <img 
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    
                    {/* Hover Overlay - Desktop only */}
                    <div className="hidden sm:flex absolute inset-0 bg-gradient-to-t from-[#1c2536]/90 via-[#1c2536]/50 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300 items-end p-6">
                      <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                        <h3 className="text-white font-bold text-xl mb-2">{item.title}</h3>
                        <span className="text-white/70 text-sm">{item.category}</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Title - Always visible on mobile */}
                  <div className="sm:hidden p-3 bg-white">
                    <h3 className="text-gray-900 font-semibold text-sm">{item.title}</h3>
                    <span className="text-gray-500 text-xs">{item.category}</span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 sm:py-16 bg-gray-50 rounded-lg">
            <p className="text-gray-500 text-base sm:text-lg">Gallery coming soon</p>
          </div>
        )}

        {/* View More CTA */}
        <div className="mt-8 sm:mt-10 md:mt-12 text-center">
          <p className="text-gray-600 text-base sm:text-lg px-2">
            Want to see your space transformed? Let's discuss your project
          </p>
        </div>
      </div>
    </section>
  );
};
